import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MainRoutes from "./routes";
import PrivateRoute from "./routes/privateroute";
import SignIn from "./pages/auth/sign-in";
import Signup from "./pages/auth/sign-up";
import { Chat } from "./features/chat";
import { Toaster } from "react-hot-toast";
import { useAppDispatch, useAppSelector } from "./hooks";
import { clearChats, selectChatId } from "./states/slices/globalReducer";
import LandingPage from "./features/landingpage";
import FeedbackForm from "./features/feedback";
import { Store } from "./states/store";
import { Share } from "./features/share";

function App() {
  const chatId = useAppSelector(selectChatId);
  const token = Store.getState().auths;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!chatId) {
      dispatch(clearChats());
    }
  }, []);
  return (
    <>
      <Routes>
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <MainRoutes />
            </PrivateRoute>
          }
        />
        {/* <Route path="/" element={<Navigate to={"/"} replace />} /> */}
        <Route element={<LandingPage />} path="/" />
        <Route element={<FeedbackForm />} path="/feedback" />
        <Route element={<Share />} path="/chat/share/:id" />
        <Route element={<SignIn />} path="/sign-in" />
        <Route element={<Signup />} path="/sign-up" />
      </Routes>
      <Toaster position="top-right" />
    </>
  );
}

export default App;
